<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import 'layui/dist/css/layui.css';

export default {
  name: 'App',
  components: {}
}
</script>

<style>
body {
  margin: 0 auto;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
  scrollbar-width:none;
  /*scrollbar-width: none;  Firefox 隐藏页面滚动条 */
  /*-ms-overflow-style: none;  IE/Edge 隐藏页面滚动条 */
  /*overflow-x: hidden;  防止横向滚动条出现（可选） */
}
body::-webkit-scrollbar {
  /*display: none; Chrome/Safari/Edge 隐藏页面滚动条 */

}

</style>
